import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-add-toting',
    templateUrl: './add-toting.component.html',
    styleUrls: ['./add-toting.component.scss'],
    standalone: false
})
export class AddTotingComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() companyBankAccountList: Account[] = [];
  @Input() cashAccountList: Account[] = [];
  @Output() passEntry = new EventEmitter<any>();
  selectedAccountId: number;
  selectedAccountBalance: number;

  @Input() paidByDuitLebih: boolean;

  //2-WAY BINDING INFO
  totingDate: Date;
  remark: string;
  amount = 0;

  disabledSubmit = false;

  isReturn = false;

  ngOnInit(): void {
    this.totingDate = new Date();
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }
  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined);
    const paymentValid = isNaN(+this.amount)

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid
  }

  checkAccountBalanceSufficient() {
    let index = this.cashAccountList.findIndex(account => Number(account.ID) == Number(this.selectedAccountId));

    if (index == -1) {
      index = this.companyBankAccountList.findIndex(account => Number(account.ID) == Number(this.selectedAccountId));

      if (this.companyBankAccountList[index].Balance - this.amount < 0)
        return false;
    }
    else {
      if (this.cashAccountList[index].Balance - this.amount < 0)
        return false;
    }
    return true;
  }

  addToting() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.totingDate))).toISOString();
    const remark = (this.isReturn == true) ? "TOTING RETURN - " : "TOTING -";
    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": remark + this.amount + "(" + this.remark + ")"
    };

    const xhr = (this.isReturn == true) ? this.restapi.postRequest(this.constructApi.getReturnToting(), data) : this.restapi.postRequest(this.constructApi.getAddToting(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          // var json = JSON.parse(xhr.responseText);

          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
          this.passEntry.emit(account)
          this.reset();
          this.sharedService.openAlert("Toting operation successful!", ALERT_TYPE.SUCCESS);
          window.location.reload();
        } else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  getAccountBalance() {
    let account = this.companyBankAccountList.find(account => account.ID === Number(this.selectedAccountId));
    if (account == undefined)
      account = this.cashAccountList.find(account => account.ID === Number(this.selectedAccountId));

    return account.Balance;
  }

  submit() {
    if (this.isFieldNull()) {
      this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER)
    }
    else if (this.isReturn && this.checkAccountBalanceSufficient() == false) {
      this.sharedService.openAlert('This account does not have enough money', ALERT_TYPE.DANGER);
    }
    else {
      this.addToting();
    }
  }

  reset() {
    this.activeModal.close();
  }
}
